import React from 'react'
import { TextField, useTheme, TextFieldProps } from '@mui/material'

export type FormDateFieldProps = Omit<TextFieldProps, 'type' | 'InputLabelProps' | 'onChange'> & {
  label: string
  value: string
  onChange: (value: string) => void
  required?: boolean
}

const FormDateField: React.FC<FormDateFieldProps> = ({
  label,
  value,
  onChange,
  required = false,
  fullWidth = true,
  size = 'small',
  ...props
}) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === 'dark'

  return (
    <TextField
      {...props}
      type="date"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      fullWidth={fullWidth}
      size={size}
      slotProps={{ inputLabel: { shrink: true } }}
      sx={{
        '& input::-webkit-calendar-picker-indicator': {
          filter: isDarkMode ? 'invert(1)' : 'invert(0.4)',
          cursor: 'pointer',
          borderRadius: '4px',
          padding: '2px',
          '&:hover': {
            backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'
          }
        },
        ...props.sx
      }}
    />
  )
}

export default FormDateField
